import React from 'react';
import css from './style.scss';
import {Link} from 'react-router-dom';
import cn from 'classnames'
import Button from 'components/shared/button'
import store from 'utils/store'
import {FullContainer} from 'components/container';
import {connect} from 'react-redux'

let _AccountBox=(props)=>{
  if(props.authenticated){
    return (
      <div className={cn(css.accountBox, props.className)}>
        {props.userData.subscription.plan==="free" &&
          <Button primary small onClick={()=>{store.dispatch({type:"OPEN_PREMIUM_MODAL"})}}>Upgrade</Button>
        }
        <Link to={"/settings"}>
          <img alt="" className={css.avatar} src={props.userData.avatar ? props.userData.avatar : "/assets/placeholder/small.png"}/>
        </Link>
      </div>
    )
  }else{
    return null
  }
}

const mapStateToProps=(state)=>{
  return state.user;
}

const AccountBox=connect(mapStateToProps)(_AccountBox)

const Header=(props)=>{
  return (
    <div className={cn(css.container, props.withPadding ? css.padding : "")}>
      <Link to="/">
        <img alt="Stori logo" className={css.logo} src={process.env.REACT_APP_URL+"/assets/icons/icon-72.png"}/>
        <b>Stori.</b>
      </Link>
      <AccountBox/>
    </div>
  )
}

export const HeaderBox=(props)=>{
  return (
    <div className="shadow">
      <FullContainer>
        <div className={css.headerBox}>
          <div className={css.wrapper}>
            <h2>{props.title}</h2>
            {props.title && <p>{props.subtitle}</p>}
          </div>
        </div>
      </FullContainer>
    </div>
  )
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/index.js